import { Settings } from "luxon";

Settings.defaultZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const setTimezone = (value: string) => {
  Settings.defaultZone = value;
};
